import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IdWithIndex} from "../richemont.module";
import {IdentificationSearchResult} from "../../../record/identification-models";
import {isValidMatchOutcome, MATCH_OUTCOME} from "../../../../constants/match-outcome.enum";

@Component({
  selector: 'richemont-identifications-list',
  templateUrl: './richemont-identifications-view.component.html',
  styleUrls: ['./richemont-identifications-view.component.scss']
})
export class RichemontIdentificationsViewComponent {

  @Input() identificationResults: IdentificationSearchResult[] = [];
  @Input() currentIdentificationId: string | null = null;
  @Input() dataset: string | null = null;
  @Input() isSuperuser: boolean = false;

  @Output() setIdentificationEvent: EventEmitter<IdWithIndex> = new EventEmitter<IdWithIndex>();

  protected readonly matchOutcome = MATCH_OUTCOME;
  protected readonly isValidMatchOutcome = isValidMatchOutcome;
}

